import { useAuthStore } from '../store/auth';
import { updateApiClientToken } from './api-client';

/**
 * One-time boot check for protected apps.
 *
 * Local LMS sessions are stored by the auth store. The API validates token
 * expiry and invalidates stale sessions through the normal 401 flow.
 */
export async function bootstrapAuth(): Promise<void> {
  const token = useAuthStore.getState().token;
  if (token) {
    updateApiClientToken(token);
  }
}
